var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['v-loader', { '--white': _vm.white, '--thin': _vm.thin }]})
}
var staticRenderFns = []

export { render, staticRenderFns }